import { CompanyClientDataType } from '@upright/common/model/company-client-data/types';
import { fetchCompanyClientDataset } from '@upright/ui/api/model/company-client-data';
import { ClientDataInputRouteParams } from '@upright/ui/views/company-client-data-input-view/types';
import { queryOptions, useQuery } from '@tanstack/react-query';
import { useRouteParams } from '../../../generic/hooks/url-handling/route-params';

export const getCompanyClientDataSetOptions = <T extends CompanyClientDataType = CompanyClientDataType>(args: {
  companyId: string | undefined;
  type: T;
  isDraft: boolean;
  clientSecret?: string;
}) => {
  const { companyId, type, isDraft, clientSecret } = args;
  return queryOptions({
    queryKey: ['company-client-data-get', companyId, type, isDraft],
    queryFn: async () => {
      if (!companyId) throw Error('No companyId');
      return await fetchCompanyClientDataset(companyId, type, isDraft, clientSecret);
    },
    enabled: !!companyId,
    refetchOnMount: false,
  });
};

export function useGetCompanyClientDataset<T extends CompanyClientDataType>(
  companyId: string | undefined,
  type: T,
  isDraft: boolean,
) {
  const clientSecret = useRouteParams<ClientDataInputRouteParams>().clientSecret;
  return useQuery(
    getCompanyClientDataSetOptions<T>({
      companyId,
      type,
      isDraft,
      clientSecret,
    }),
  );
}
